import React from 'react';
import Menu from '../Home/menu';
import { BuyTicket } from '../Contact/buyTicket';
import { Footer } from '../Home/footer';
import pastEdotionBannerImg from '../../Assets/images/Hero Image 1.svg';

export const PastEditions = () => {
    const pData = [
        {
            year:"2018",
            link:"https://youtu.be/Esb_Kh3i1lE?si=n_kU2rBEg2b3sf7H"
        },
        {
            year:"2019",
            link:"https://youtu.be/AlmIeMUaNdc?si=dPODiFMRDLjfFPDO"
        },
        {
            year:"2021",
            link:"https://youtu.be/ocOzFaAaHzw?si=ry7Yqjp-wJR95aWo"
        },
        {
            year:"2022 - VFX Summit",
            link:"https://youtu.be/jqCGm67Bl6s?si=huqHShHrVzpoOcA9"
        },
        {
            year:"2022 - IGDC",
            link:"https://youtu.be/I672STWIEwA?si=TztlbWKFhV8N4w1Y"
        },
        {
            year:"2022 - Indywood",
            link:"https://youtu.be/f8kvO3v34sg?si=MsWtwPnjtswsEvUT"
        }
    ]
    return (
        <div>
            <Menu />
            <div className='indiaJoy__pastEdition__wrapper'>
                <div className='indiaJoy__pastEdition__container'>
                    <div className='indiaJoy__pastEdition__item1'>
                    <h2>Past <br/> Editions</h2><br/>
                        <h3>2023</h3>
                        <a href="https://youtu.be/ARYjTbP15Aw?si=Okxw5GmhJcOBswip" target="_blank" rel="noopener noreferrer">
                        <div className='indiaJoy__pastEdition__card'></div>
                        </a>
                    </div>
                    <div className='indiaJoy__pastEdition__item2'>
                        <img src={pastEdotionBannerImg} alt='pastEdotionBannerImg' />
                    </div>
                </div>
                <div className='indiaJoy__pastEdition__section'>
                {pData.map((item, index) => (
                    <div key={index} className='indiaJoy__pastEdition__item3'>
                       <h2>{item?.year}</h2>
                       <a href={item?.link} target="_blank" rel="noopener noreferrer">
                       <div className='indiaJoy__pastEdition__card2'></div>
                       </a>
                    </div>
                ))}
                </div>
            </div>
            <BuyTicket />
            <Footer />
        </div>
    )
}
